import { queryKeyFn } from '../../generated/sitContext';
export const getAdminTriggersPackagesQueryKey = queryKeyFn({
    path: '/admin/triggers-packages',
    operationId: 'getApiAdminTriggersPackages',
    variables: {},
});
export function invalidateAdminCompanyTreeQueryData(queryClient) {
    return Promise.all([
        queryClient.invalidateQueries({
            queryKey: getAdminTriggersPackagesQueryKey,
        }),
        queryClient.invalidateQueries({ queryKey: ['admin', 'companies'] }),
    ]);
}
export function updateAdminCompanyTreeQueryData(queryClient, companyTreeSettingsId, updater) {
    const castedId = `${companyTreeSettingsId}`;
    queryClient.setQueryData(['admin', 'companies'], (data) => {
        if (!data) {
            return data;
        }
        return data.map((company) => `${company.id}` === castedId ? updater(company) : company);
    });
    queryClient.setQueryData(queryKeyFn({
        path: '/admin/companies/{id}',
        operationId: 'getApiAdminCompanyByCompanyTreeSettingsId',
        variables: {
            pathParams: {
                id: `${companyTreeSettingsId}`,
            },
        },
    }), (data) => {
        if (!data) {
            return data;
        }
        return updater(data);
    });
}
//# sourceMappingURL=query.js.map